import {Component, OnInit} from '@angular/core';
import {StorageService} from '@shared/services/storage.service';
import {environment} from '../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IamAppConstants} from '../../iam/shared/iam-app-constants';
import {AuthService} from '@shared/services/auth.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html'
})
export class LoginPageComponent implements OnInit {
  showLoginScreen = false;
  submitted = false;
  error = '';
  loginForm!: FormGroup;
  userId!: any;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router
  ) {
  }

  ngOnInit() {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const dblogin = queryParams.hasOwnProperty('dblogin');

    if (dblogin) {
      // Only render the DB login form if IAM reports it is enabled; this keeps
      // the UI in step with the backend, which is the single source of truth.
      this.authService.getLoginConfig().subscribe({
        next: (config) => {
          if (config?.dbLoginEnabled) {
            this.initLoginForm();
            this.showLoginScreen = true;
          } else {
            this.redirectToSamlOrStay();
          }
        },
        error: () => this.redirectToSamlOrStay()
      });
    } else if (environment.enableSaml) {
      globalThis.location.href = this.getSamlLoginUrl();
    }
  }

  private redirectToSamlOrStay() {
    if (environment.enableSaml) {
      globalThis.location.href = this.getSamlLoginUrl();
    }
  }

  private getSamlLoginUrl() {
    return environment.samlLoginUrl;
  }


  initLoginForm() {
    this.loginForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$' // NOSONAR
          )
        ]
      ],
      password: ['', [Validators.required]]
    });
  }

  public login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.authService
      .login(
        IamAppConstants.AuthType.DB_AUTH,
        this.loginForm.value.email,
        this.loginForm.value.password
      ).subscribe(tokenDetails => {
      location.href = `/auth/saml/callback?code=${tokenDetails.token}`;
    })

  }

  handleDropdownKey(event: any) {
    return IamAppConstants.handleDropdownKey(event);
  }
}
